import { gql } from '@apollo/client';

import { GlobalStyles } from '@/types/GlobalStyles';
import { UserErrors } from '@/types/UserErrors';

export const UpdateStyles = gql`
  mutation UpdateStyles($input: UpdateStylesInput!) {
    updateStyles(input: $input) {
      userErrors {
        code
        message
        path
      }
    }
  }
`;

export type UpdateStylesMutationResult = {
  updateStyles: {
    userErrors: UserErrors;
  };
};

export type UpdateStylesMutationVariables = {
  input: {
    styles: GlobalStyles;
    presetName?: string;
  };
};
